import React from "react";
// import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import {render} from "react-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";

const root = document.getElementById("root");
// const root = createRoot(rootElement);

render(<App />, root);
// ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

